<template>
    <BaseForm>
        <template #title>
            <v-row align="center"> 
                <v-col>Заполните дополнительные данные</v-col> 
                <Solutions class="pl-8"/>
            </v-row>
        </template>
        <v-form ref="form">
            <v-row>
                <Field v-for="name in [
                        'maritalStatus',
                        'childsCount',
                        'homePhone',
                        'additionalPhone',
                        'education',
                        'employmentType',
                        // 'inn',
                        // 'position',
                        // 'workPhone',
                    ]" 
                    :key="name"
                    :anketaName="name"
                    />
            </v-row>
        </v-form>
        <v-form>
            <v-row>
                <Field v-for="name in [
                        'inn',
                        'position',
                        'workPhone',
                    ]" 
                    :key="name"
                    :anketaName="name"
                    />
            </v-row>
        </v-form>
        <template #buttons>
            <Button 
                style="float:right"
                @click="next"
                :loading="isLoading"
                >
                Отправить
            </Button>
        </template>
    </BaseForm>
</template>

<script>
import Solutions from '../controls/Solutions.vue';

export default {
    components: { Solutions },
    watch: {
        '$anketa.employmentType.value'(val) {
            const isHidden = [5,6,7,8].some(el => el == val.id);

            // console.log('$anketa.employmentType.value', val, isHidden);           
            this.$anketa.position.visible = !isHidden;
            this.$anketa.workPhone.visible = !isHidden;
        }
    },
    data: () => ({ isLoading: false }),
    methods: {
        next() {
            if (this.$refs.form.validate()) {

                this.isLoading = true;
                this.$connector.SendFullApplication().then(
                    data => {
                        this.isLoading = false;

                        if (data.isSuccess) {
                            this.$forms.open('Approved');
                        }
                    }
                );
            }
        },
    //     showModals() {
    //         let modals = [
    //             'SendRequest',
    //             'ApplicationPending',
    //             'TimeOut',
    //             'Error',
    //             'Denial',
    //             'AnotherChoise',
    //             'Approve',
    //             'ContinueToFill',
    //             // 'FoundAccount',
    //             'Link'
    //         ];


    //         modals.forEach((modal,i) => {
    //             setTimeout(
    //                 () => this.$modals.open(modal),
    //                 10000 * i++
    //             )
    //         });

    //         setTimeout(
    //             () => {
    //                 this.$modals.close();
    //                 this.$forms.open('Approved')
    //             },
    //             10000 * modals.length
    //         )
    //    } 
    },

}
</script>
